import { getFiscalYear } from "./dateTime";

const unitValueTypes = {
  "PAID UNITS": "PAID UNITS",
  "UNPAID UNITS": "UNPAID UNITS",
};
const taxValueTypes = {
  "PAID TAX": "PAID TAX",
  "UNPAID TAX": "UNPAID TAX",
  "COLLECTED TAX": "COLLECTED TAX",
};

const getColorValueBasedOnType = (type) => {
  if (
    type === unitValueTypes["PAID UNITS"] ||
    type === taxValueTypes["PAID TAX"] ||
    type === taxValueTypes["COLLECTED TAX"]
  ) {
    return "#006400";
  }
  if (
    type === unitValueTypes["UNPAID UNITS"] ||
    type === taxValueTypes["UNPAID TAX"]
  ) {
    return "#FF6347";
  }
  if (
    type === unitValueTypes["PENDING UNITS"] ||
    type === taxValueTypes["PENDING TAX"]
  ) {
    return "#FCAE1F";
  }
};

export const formatYearlyTotalAndPaidTax = (data, numberOfYearsSelected) => {
  let taxYearlyData = [];
  data?.forEach((item) => {
    taxYearlyData.push(
      {
        tax: +item?.tax_paid,
        name: "PAID TAX",
        year: `${+item?.taxyear}\n(current)`,
      },
      {
        tax: +item?.tax_unpaid,
        name: "UNPAID TAX",
        year: `${+item?.taxyear}\n(current)`,
      }
    );
  });

  let existingYearsObject = {};
  taxYearlyData.forEach((item) => {
    if (!existingYearsObject[item.year]) {
      existingYearsObject[item.year] = item.year;
    }
  });
  const currentYear = getFiscalYear();
  let restOfYearsArr = [];
  if (numberOfYearsSelected) {
    for (
      let i = currentYear - (numberOfYearsSelected - 1);
      i <  currentYear ;
      i++
    ) {
      if (!existingYearsObject[i]) {
        restOfYearsArr.push(
          {
            tax: 0,
            name: "PAID TAX",
            year: i,
          },
          { tax: 0, name: "UNPAID TAX", year: i }
        );
      }
    }
  }

  taxYearlyData = [...restOfYearsArr, ...taxYearlyData];
  let initialThreeYearsData = taxYearlyData.slice(-9);
  return [taxYearlyData, initialThreeYearsData];
};
export const formatUnitsOfProperties = (data, numberOfUnitsSelected) => {
  let unitsData = [];
  data?.forEach((item) => {
    unitsData.push(
      {
        units: +item?.tax_paid_units,
        name: "PAID UNITS",
        year: `${+item?.taxyear}\n(current)`,
      },
      {
        units: +item?.tax_unpaid_units,
        name: "UNPAID UNITS",
        year: `${+item?.taxyear}\n(current)`,
      }
    );
  });

  let existingYearsObject = {};
  unitsData.forEach((item) => {
    if (!existingYearsObject[item.year]) {
      existingYearsObject[item.year] = item.year;
    }
  });
  const currentYear = getFiscalYear();
  let restOfUnitsArr = [];
  if (numberOfUnitsSelected) {
    for (
      let i = currentYear - (numberOfUnitsSelected - 1);
      i < currentYear ;
      i++
    ) {
      if (!existingYearsObject[i]) {
        restOfUnitsArr.push(
          {
            units: 0,
            name: "PAID UNITS",
            year: i,
          },
          {
            units: 0,
            name: "UNPAID UNITS",
            year: i,
          }
        );
      }
    }
  }
  unitsData = [...restOfUnitsArr, ...unitsData];
  let initialThreeYearsData = unitsData.slice(-9);
  return [unitsData, initialThreeYearsData];
};

export const customColorFunction = ({ name }) => {
  if (name === unitValueTypes[name] || name === taxValueTypes[name]) {
    return getColorValueBasedOnType(name);
  }
};

export const formatLabelFunction = (val) => {
  return val?.units || val?.tax?.toLocaleString();
};

export const tooltipFormatterFunction = (val) => ({
  name: val?.name,
  value: `Rs ` + val?.tax?.toLocaleString(),
});
